import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/common/Tabs';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import GeneralInformationTab from './tabs/GeneralInformationTab';
import OperationInformationTab from './tabs/OperationInformationTab';
import ShopInformationTab from './tabs/ShopInformationTab';
import AppointmentInformationTab from './tabs/AppointmentInformationTab';
import { useTranslation } from 'react-i18next';
import SeoSetting from '@/pages/seo-tool/components/SeoSetting';
import { SEO_ENTITY_TYPE } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { toJS } from 'mobx';
import { SHOP_CATEGORY_TYPE, SHOP_STATUS_TYPE } from '@/types/enums';

// state
const SHOP_INFO_TABS = [
    {
        key: 'create_shop_tab_general',
        tab: <GeneralInformationTab />
    },
    {
        key: 'create_shop_tab_info',
        tab: <ShopInformationTab />
    },
    {
        key: 'create_shop_tab_operation',
        tab: <OperationInformationTab />
    },
    {
        key: 'create_shop_tab_appointment',
        tab: <AppointmentInformationTab />
    },
    {
        key: 'seo_shop',
        tab: <SeoSetting seoEntityType={SEO_ENTITY_TYPE.SHOP} />
    }
];

export default observer(function EditShopPage() {
    const [activeTab, setActiveTab] = useState(SHOP_INFO_TABS[0].key);
    const { t } = useTranslation();

    const {
        shopStore: { shopInfo }
    } = useStore();

    // function
    const handleTabChange = (value) => {
        setActiveTab(value);
    };

    const TabList = useMemo(() => {
        if (shopInfo?.code) {
            if (shopInfo?.categoryIds && shopInfo?.categoryIds.length > 0 &&
                (shopInfo?.categoryIds.includes(SHOP_CATEGORY_TYPE.PetHospital) || shopInfo?.categoryIds.includes(SHOP_CATEGORY_TYPE.PetShop))
            ) {
                return SHOP_INFO_TABS;
            } else {
                return SHOP_INFO_TABS.filter(item => item.key !== 'create_shop_tab_appointment');
            }
        } else {
            return SHOP_INFO_TABS.filter(item => item.key !== 'create_shop_tab_operation' && item.key !== 'create_shop_tab_appointment');
        }
    }, [shopInfo]);

    return (
        <div>
            <Tabs value={activeTab} onValueChange={handleTabChange} className='w-full h-full flex flex-col'>
                <TabsList variant='editShop' data-orientation='horizontal' className='flex w-full overflow-x-auto bg-white rounded'>
                    {TabList.map((tab, index) =>
                        (<TabsTrigger key={index} variant='editShop' className='w-full' value={tab.key}>{t(`words_title.${tab.key}`)}</TabsTrigger>))}
                </TabsList>
                <div className='bg-background-2'>
                    {
                        TabList.map((item, index) => (
                            <TabsContent key={index} value={item.key}>
                                {item.tab}
                            </TabsContent>
                        ))
                    }
                </div>
            </Tabs>
        </div>
    );
});
